import { captureSentryException } from "@/lib/client/utils/captureSentryException";
import { useEffect } from "react";

export default function GenericErrorRetry({ error }: { error: unknown }) {
  useEffect(() => {
    captureSentryException(error);
    console.error("GenericErrorRetry", error);
  }, [error]);

  return null;
}
